import { KVPosition } from 'types'

// Measurement-specific functions
export function parsePosition(positionString: string): KVPosition | null {
  try {
    const xMatch = positionString.match(/X=([-\d.]+)/)
    const yMatch = positionString.match(/Y=([-\d.]+)/)
    const zMatch = positionString.match(/Z=([-\d.]+)/)

    if (xMatch && yMatch && zMatch) {
      return new KVPosition(
        parseFloat(xMatch[1]),
        parseFloat(yMatch[1]),
        parseFloat(zMatch[1])
      )
    }
  } catch (_error) {
    console.warn('Failed to parse position string:', positionString, _error)
  }
  return null
}

// Calculate distance between two 3D points
export function calculateDistance(start: KVPosition, end: KVPosition): number {
  const dx = end.x - start.x
  const dy = end.y - start.y
  const dz = end.z - start.z
  return Math.sqrt(dx * dx + dy * dy + dz * dz)
}
